export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <rect stroke="#979797" strokeWidth="2" x="14" y="25" width="34" height="24" rx="4" />
                <rect stroke="#979797" strokeWidth="2" x="7" y="17" width="63" height="40" rx="5" />
                <circle stroke="#979797" fill="#D8D8D8" cx="62" cy="31" r="1" />
                <circle stroke="#979797" fill="#D8D8D8" cx="62" cy="40" r="1" />
                <path stroke="#979797" strokeWidth="2" strokeLinecap="round" d="M16.5 58v2M59.5 58v2M55.5 18l.268 38.743" />
            </g>
        </svg>
    );
}
